import {
    Card,
    CardContent,
    Typography,
    Modal,
    CardHeader,
    IconButton,
    makeStyles
} from '@material-ui/core';
import { injectIntl } from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
    root: {
        position: 'absolute',
        overflow: 'scroll',
        height: '100vh',
        display: 'flex',
        zIndex: '3000 !important'
    },
    backdrop: {
        backgroundColor: `white !important`,
        opacity: 0.9
    },
    inner: {
        width: '100%',
        margin: "auto",
        overflow: 'scroll',
        maxWidth: 600,
        //display: 'flex',
        backgroundColor: 'white',
        '&:focus': {
            outline: 'none !important'
        },
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        position: 'relative',
        borderRadius: 10
    },
    content: {
        marginTop: theme.spacing(2),
    },
    closebtn: {
        borderRadius: 100
    },
    cardHeader: {
        backgroundColor: theme.palette.app.primary
    },
    headerTitle: {
        color: 'white',
        fontSize: 20,
        lineHeight: '25px'
    },
}));


const AnounceModal = props => {
    const {
        open,
        closeModal
    } = props;
    const classes = useStyles();

    return (
        <Modal
            className={classes.root}
            open={open}
            onClose={closeModal}
            aria-labelledby="users-modal-title"
            aria-describedby="users-modal-description"
            BackdropProps={{ className: classes.backdrop }}
        >
            <Card className={classes.inner}>
                <CardHeader
                    title={"Urgent - Ne manquez pas le changement d’adresse de votre Espace Client Apave !"}
                    titleTypographyProps={{ className: classes.headerTitle }}
                    className={classes.cardHeader}
                    action={
                        <IconButton onClick={closeModal}>
                            <CloseIcon style={{ fill: 'white' }} />
                        </IconButton>
                    }
                />
                <CardContent>
                    <div>
                        <Typography variant="h6"><strong>
                            Depuis le 1er avril, l’adresse de votre Espace Client Apave a évolué afin de vous offrir une expérience plus fluide et sécurisée.<br /><br />
                            Nouvelle URL : <a href='https://espaceclient.apave.com' target='_blank'>https://espaceclient.apave.com</a><br /><br />
                            Petit conseil : pensez à enregistrer cette adresse dans vos favoris pour un accès simplifié.<br /><br /></strong></Typography>
                    </div>
                </CardContent>
            </Card>
        </Modal >
    );
};

AnounceModal.propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }),
    open: PropTypes.bool,
    closeModal: PropTypes.func
};

export default injectIntl(AnounceModal);
